<template>
    <div>
        <Pane title="重新提交设计输入需求" :showRemarks="false">
            <template>重新发起设计输入需求流程</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 12 }">
                <a-form :model="form" layout="horizontal" :colon="false" label-align="right"
                        :label-col="{ span: 8 }"
                        :wrapper-col="{ span: 12 }">
                    <div class="title" style="margin-top: 0">基本信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="12">
                                <a-form-item label="工程名称">
                                    <a-input v-model="form.projectName" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="项目阶段">
                                    <a-input v-model="form.phaseName" disabled />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="所属专业">
                                    <a-select v-model="form.majors" mode="multiple" placeholder="">
                                        <a-select-option v-for="item in majorList" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计负责人">
                                    <a-select
                                        mode="multiple"
                                        :value="designLeaderEmployees.map(e => e.userId)"
                                        placeholder="请选择设计负责人"
                                        @change="handleDesignLeaderSelect"
                                        style="width: 100%"
                                    >
                                        <a-select-option v-for="item in designLeaderOptions" :key="item.userId" :value="item.userId">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="分管总工">
                                    <a-select
                                        show-search
                                        :filter-option="$selectFilterOption"
                                        label-in-value
                                        :value="selectedDeptChiefEngineer"
                                        placeholder="请选择分管总工"
                                        @change="handleChiefEngineerSelect"
                                        style="width: 100%"
                                    >
                                        <a-select-option v-for="item in chiefEngineerOptions" :key="item.userId" :value="item.userId">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="专业负责人">
                                    <a-select
                                        mode="multiple"
                                        :value="majorLeaderEmployees.map(e => e.userId)"
                                        placeholder="请选择专业负责人"
                                        @change="handleMajorLeaderSelect"
                                        style="width: 100%"
                                    >
                                        <a-select-option v-for="item in majorLeaderOptions" :key="item.userId" :value="item.userId">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>
                    <div class="title">详细信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="24">
                                <a-form-item label="各专业审核人" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <a-select
                                        mode="multiple"
                                        :value="auditorEmployees.map(e => e.userId)"
                                        placeholder="请选择各专业审核人"
                                        @change="handleAuditorSelect"
                                        style="width: 100%"
                                    >
                                        <a-select-option v-for="item in auditorOptions" :key="item.userId" :value="item.userId">
                                            {{ item.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item label="设计输入要求内容" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea v-model="form.reqContent" :rows="4" style="max-width: 100%!important;width: 100%!important;" placeholder="请输入设计输入要求内容" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>
                    <div class="title">其他信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :span="24">
                                <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <a-textarea v-model="form.remark" :rows="3" style="max-width: 100%!important;width: 100%!important;" placeholder="请输入备注" />
                                </a-form-item>
                            </a-col>
                            <a-col :span="24">
                                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" label="附件">
                                    <Attachment :editable="true" :fileList="fileList" @change="fileList = $event" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { fetchDesignInputReqDetail, resubmitDesignInputReq } from '@/api/project-plan/inputreq'
import { fetchPrjTaskPhaseSummary } from '@/api/project-execute/result'
import { parseAttachment, buildAttachmentData } from '@/utils/attachment'
import Attachment from "@/components/attachment";
import { getPersonnel, getCompanyPersonnel } from '@/api/project-approval/review'

export default {
    name: "DesignInputReqReapply",
    components: { Attachment },
    data() {
        return {
            loading: false,
            submitting: false,
            id: "",
            taskId: "",
            instanceId: "",
            form: {
                projectName: "",
                phaseName: "",
                majors: [],
                reqContent: "",
                remark: "",
            },
            fileList: [],
            designLeaderEmployees: [],
            designLeaderOptions: [],
            chiefEngineerEmployee: { name: '', userId: '' },
            majorLeaderEmployees: [],
            majorLeaderOptions: [],
            auditorEmployees: [],
            auditorOptions: [],
            deptChiefEngineers: [],
            companyChiefEngineers: [],
            selectedDeptChiefEngineer: undefined,
            phaseSummary: null,
        };
    },
    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        majorList() {
            const codes = (this.phaseSummary?.majors || '').split(',').filter(Boolean);
            const dictList = (this.findDataDict && this.findDataDict("cosys.major")) || [];
            return codes.map(m => {
                const found = dictList.find(item => item.value === m);
                return { value: m, name: found ? found.name : m };
            });
        },
        manageLevel() {
            return (this.phaseSummary && this.phaseSummary.manageLevel) || ''
        },
        isCompanyLevel() {
            return this.manageLevel === 'company'
        },
        chiefEngineerOptions() {
            return this.isCompanyLevel ? this.companyChiefEngineers : this.deptChiefEngineers
        },
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.id = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }

        this.fetchDetail();
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        async fetchDetail() {
            if (!this.id) {
                this.loading = false;
                return;
            }
            this.loading = true;
            try {
                const data = await fetchDesignInputReqDetail(this.id);
                if (!data) return;
                this.form = {
                    projectName: data.projectName || "",
                    phaseName: data.phaseName || "",
                    majors: data.majors ? data.majors.split(',') : [],
                    reqContent: data.reqContent || "",
                    remark: data.remark || "",
                };
                if (data.designLeaderId && data.designLeaderName) {
                    const ids = data.designLeaderId.split(',');
                    const names = data.designLeaderName.split(',');
                    this.designLeaderEmployees = ids.map((id, idx) => ({ userId: id, name: names[idx] || '' }));
                    this.designLeaderOptions = this.designLeaderEmployees.map(e => ({ ...e }));
                } else {
                    this.designLeaderEmployees = [];
                    this.designLeaderOptions = [];
                }
                this.chiefEngineerEmployee = { name: data.chiefEngineerName || '', userId: data.chiefEngineerId || '' };
                this.selectedDeptChiefEngineer = this.chiefEngineerEmployee.userId ? { key: this.chiefEngineerEmployee.userId, label: this.chiefEngineerEmployee.name } : undefined;
                if (data.majorLeaderIds && data.majorLeaderNames) {
                    const ids = data.majorLeaderIds.split(',');
                    const names = data.majorLeaderNames.split(',');
                    this.majorLeaderEmployees = ids.map((id, idx) => ({ userId: id, name: names[idx] || '' }));
                    this.majorLeaderOptions = this.majorLeaderEmployees.map(e => ({ ...e }));
                } else {
                    this.majorLeaderEmployees = [];
                    this.majorLeaderOptions = [];
                }
                if (data.auditorIds && data.auditorNames) {
                    const ids = data.auditorIds.split(',');
                    const names = data.auditorNames.split(',');
                    this.auditorEmployees = ids.map((id, idx) => ({ userId: id, name: names[idx] || '' }));
                    this.auditorOptions = this.auditorEmployees.map(e => ({ ...e }));
                } else {
                    this.auditorEmployees = [];
                    this.auditorOptions = [];
                }
                this.fileList = parseAttachment(data.attachment, data.attachmentPaths);

                console.log("phaseId:::",data.phaseId)
                if (data.phaseId) {
                    console.log("data.phaseId:::",data.phaseId)
                    const summary = await fetchPrjTaskPhaseSummary(data.phaseId);
                    console.log("summary:::",summary)
                    if (summary) {
                        this.phaseSummary = summary;
                    }
                }
                const orgId = this.phaseSummary?.mainDeptId || data.mainDeptId || data.prodDeptId;
                this.fetchPersonnel(orgId);
            } finally {
                this.loading = false;
            }
        },
        handleDesignLeaderSelect(userIds) {
            this.designLeaderEmployees = userIds.map(id => {
                const item = this.designLeaderOptions.find(o => o.userId === id);
                return item ? { userId: item.userId, name: item.name } : { userId: id, name: '' };
            });
        },
        handleChiefEngineerSelect(val) {
            if (val && val.key) {
                this.selectedDeptChiefEngineer = val;
                this.chiefEngineerEmployee = { userId: val.key, name: val.label };
            } else {
                this.selectedDeptChiefEngineer = undefined;
                this.chiefEngineerEmployee = { userId: '', name: '' };
            }
        },
        handleMajorLeaderSelect(userIds) {
            this.majorLeaderEmployees = userIds.map(id => {
                const item = this.majorLeaderOptions.find(o => o.userId === id);
                return item ? { userId: item.userId, name: item.name } : { userId: id, name: '' };
            });
        },
        handleAuditorSelect(userIds) {
            this.auditorEmployees = userIds.map(id => {
                const item = this.auditorOptions.find(o => o.userId === id);
                return item ? { userId: item.userId, name: item.name } : { userId: id, name: '' };
            });
        },
        async fetchPersonnel(orgId) {
            if (!orgId) return;
            try {
                const normalize = items => (items || []).map(item => ({ ...item, userId: item.userId || item.id }));
                if (this.isCompanyLevel) {
                    const companyRes = await getCompanyPersonnel(orgId);
                    this.companyChiefEngineers = normalize(companyRes.companyChiefEngineers);
                    const personnelRes = await getPersonnel(orgId);
                    this.deptChiefEngineers = normalize(personnelRes.deptChiefEngineers);
                } else {
                    const res = await getPersonnel(orgId);
                    this.deptChiefEngineers = normalize(res.deptChiefEngineers);
                }
                const options = this.chiefEngineerOptions;
                if (!this.chiefEngineerEmployee.userId && options.length) {
                    const ce = options[0];
                    this.chiefEngineerEmployee = { userId: ce.userId, name: ce.name };
                    this.selectedDeptChiefEngineer = { key: ce.userId, label: ce.name };
                }
            } catch (e) {
                console.error('获取人员列表失败', e);
            }
        },
        submitReview() {
            this.submitting = true;
            const { attachment, attachmentPaths } = buildAttachmentData(this.fileList);
            const data = {
                id: this.id,
                projectName: this.form.projectName,
                phaseName: this.form.phaseName,
                majors: Array.isArray(this.form.majors) ? this.form.majors.join(',') : this.form.majors,
                designLeaderId: this.designLeaderEmployees.map(e => e.userId).join(','),
                designLeaderName: this.designLeaderEmployees.map(e => e.name).join(','),
                chiefEngineerId: this.chiefEngineerEmployee.userId,
                chiefEngineerName: this.chiefEngineerEmployee.name,
                majorLeaderIds: this.majorLeaderEmployees.map(e => e.userId).join(','),
                majorLeaderNames: this.majorLeaderEmployees.map(e => e.name).join(','),
                auditorIds: this.auditorEmployees.map(e => e.userId).join(','),
                auditorNames: this.auditorEmployees.map(e => e.name).join(','),
                majorNames: Array.isArray(this.form.majors) ? this.form.majors.map(m => {
                    const found = this.majorList.find(item => item.value === m);
                    return found ? found.name : m;
                }).join(',') : '',
                reqContent: this.form.reqContent,
                remark: this.form.remark,
                attachment,
                attachmentPaths,
            };
            resubmitDesignInputReq(data)
                .then(() => {
                    const extra = {
                        ...this.$store.state.approval.detail?.extra,
                        ...this.form,
                    };
                    delete extra.seqNum;
                    return this.finishTask({
                        notifyPeople: [],
                        map: { operation: "COMPLETED" },
                        extra: JSON.stringify(extra),
                    });
                })
                .then(() => {
                    this.$close(this.$route.path, "/project-service/approval/task");
                })
                .catch((e) => {
                    console.error("提交失败详情", e);
                    this.$message.error("提交失败");
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        goBack() {
            this.$close(this.$route.path);
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.wrapper {
    background-color: #f9f9f9;
    padding-top: 24px;
    padding-bottom: 8px;
}

.title {
    font-weight: bold;
    font-size: 17px;
    margin: 12px 0;
}

.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}
</style>
